/* eslint-disable */
export default {
  Home: 'Privat',
  Mobile: 'Mobiltelefon',
  Work: 'Arbeit',
} as const;

// @key: @#@"Home"@#@ @source: @#@"Home"@#@
// @key: @#@"Mobile"@#@ @source: @#@"Mobile"@#@
// @key: @#@"Work"@#@ @source: @#@"Work"@#@
